<template>
  <TableLayout :permissions="['business:orgs:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" >
      <el-form-item label="名称" prop="name">
        <el-input v-model="searchForm.name" placeholder="请输入机构名称" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:orgs:create', 'business:orgs:delete']">
        <li><el-button type="primary" @click="$refs.operaOrgsWindow.open('新建机构')" icon="el-icon-plus" v-permissions="['business:orgs:create']">新建</el-button></li>
        <!-- <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['business:orgs:delete']">删除</el-button></li> -->
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        border
        @selection-change="handleSelectionChange"
      >
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column prop="loginname" label="登陆账号" align="center" min-width="100px"></el-table-column>
        <el-table-column prop="name" label="机构名称" align="center" min-width="100px"></el-table-column>
        <el-table-column label="机构LOGO" align="center" min-width="100px">
          <template slot-scope="{row}">
            <!-- {{ row.imgFullUrl+row.imgurl }} -->
            <el-image :scr="row.imgFullUrl+row.imgurl" :preview-src-list="[row.imgFullUrl+row.imgurl]"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="addr" label="地址" align="center" min-width="100px"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" align="center" min-width="100px"></el-table-column>
        <el-table-column prop="memberId" label="机构负责人" align="center" min-width="100px">
          <template slot-scope="{row}">
            {{ `${row.nikeName} ${row.phone}` }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" align="center" min-width="100px">
          <template slot-scope="{row}">
            <el-switch
              v-model="row.status"
              active-color="#13ce66"
              inactive-color="#999"
              :active-value="0"
              :inactive-value="1"
              @change="statusChange(row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column
          v-if="containPermissions(['business:orgs:update', 'business:orgs:delete'])"
          label="操作"
          min-width="120"
          fixed="right"
          align="center"
        >
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.operaOrgsWindow.open('编辑机构', row)" icon="el-icon-edit" v-permissions="['business:orgs:update']">编辑</el-button>
            <el-button type="text"  style="color: red;" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['business:orgs:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaOrgsWindow ref="operaOrgsWindow" @success="handlePageChange"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaOrgsWindow from '@/components/business/OperaOrgsWindow'
import { updateStatusById } from '@/api/business/orgs'
export default {
  name: 'Orgs',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaOrgsWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        id: '',
        creator: '',
        createDate: '',
        editor: '',
        editDate: '',
        isdeleted: '',
        remark: '',
        loginname: '',
        name: '',
        imgurl: '',
        status: '',
        areaId: '',
        addr: '',
        info: '',
        userId: '',
        memberId: ''
      }
    }
  },
  created () {
    this.config({
      module: '机构信息表',
      api: '/business/orgs',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  },
  methods: {
    statusChange(row) {
      updateStatusById(row)
        .then(() => {
          this.$message.success('操作成功')
        })
        .catch(e => {
          this.$message.error(e)
        })
        .finally(() => {
          this.handlePageChange()
        })
    }
  },
}
</script>
